import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { Site } from '@classes/site';
import { SiteDetail } from '@classes/site-detail';
import { MessageBox } from '@components/message-box/message-box.component';
import { TranslateService } from '@ngx-translate/core';
import { AutocompleteObjectValidator } from '@shared/validators/autocomplete-object-validator';
import { SiteService } from 'app/core/services/site.service';
import { UiService } from 'app/core/services/ui.service';
// import { environment } from 'environments/environment';

import * as _moment from 'moment';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { of } from 'rxjs';
import { SitePicture } from '@classes/site-picture';
import { SitePictureComponent } from '../site-picture/site-picture.component';
import { Role } from '@enums/role.enum';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

const moment = _moment;

@Component({
  selector: 'app-site-detail',
  templateUrl: './site-detail.component.html',
  styleUrls: ['./site-detail.component.scss'],
  styles: [`
  >>> app-site-detail {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
`]
})
export class SiteDetailComponent implements OnInit {
  environment = this.envConfigurationService.environment;

  upload = false;
  siteForm: FormGroup;
  siteDetail: SiteDetail;

  lat: number;
  lng: number;

  imageArray: (SitePicture)[] = [];
  imageArrayMaxLength = this.environment.maxSitePicture;
  pictureSiteType = this.environment.pictureSiteType;

  Role = Role;

  @Input() set siteDetail_(siteDetail: SiteDetail) {
    this.siteDetail = siteDetail;
    if (siteDetail?.id) {
      this.uiService.addRouteLoading();
      this.siteService.getSite(siteDetail?.id).subscribe(site => {
        this.siteDetail.site = site;
        this.uiService.removeRouteLoading();
        this.getPicture();
        this.initFormBuilder(site);
      }, error => {
        console.error(error);
        this.uiService.removeRouteLoading();
      })
    }
    else {
      this.initFormBuilder();
    }
  };

  @Output() siteDetailEmit = new EventEmitter<any>();
  @ViewChild('fileUpload', { static: false }) fileUpload: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private autocompleteObjectValidator: AutocompleteObjectValidator,
    public siteService: SiteService,
    public uiService: UiService,
    public dialog: MatDialog,
    public envConfigurationService: EnvConfigurationService,
    public translateService: TranslateService,
    @Optional() public dialogRef: MatDialogRef<SiteDetailComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: SiteDetail
  ) { }

  ngOnInit() {
    if (this.data) {
      this.siteDetail = this.data;
    }
    this.initFormBuilder();
  }



  private initFormBuilder(value?: Site) {
    var disabled = !(this.siteDetail?.isEditMode || this.siteDetail?.isCreationMode);
    const fb = this.formBuilder;
    this.siteForm = fb.group({
      id: fb.control(value?.id),
      name: fb.control({ value: value?.name, disabled: disabled }, [Validators.required]),
      area: fb.control({ value: value?.area, disabled: disabled }, []),
      addressId: fb.control({ value: value?.addressId, disabled: true }),
      address: fb.group({
        id: fb.control(value?.address?.id),
        address1: fb.control({ value: value?.address?.address1, disabled: disabled }, []),
        city: fb.control({ value: value?.address?.city, disabled: disabled }, []),
        zip: fb.control({ value: value?.address?.zip, disabled: disabled }, []),
      }),
      // dockType: fb.control({ value: value?.dockType, disabled: disabled }, [this.autocompleteObjectValidator.autocompleteObjectValidator()]),
      // accessType: fb.control({ value: value?.accessType, disabled: disabled }, [this.autocompleteObjectValidator.autocompleteObjectValidator()]),
      siteMode: fb.control({ value: value?.siteMode, disabled: disabled }, [this.autocompleteObjectValidator.autocompleteObjectValidator()]),
      isPaco: fb.control({ value: value?.isPaco, disabled: disabled }, []),
      modifiedDate: fb.control({
        value: value?.modifiedDate
          ? moment(value?.modifiedDate).format("YYYY-MM-DDTHH:mm")
          : value?.creationDate
            ? moment(value?.creationDate).format("YYYY-MM-DDTHH:mm")
            : "",
        disabled: true
      }, []),
      modifiedUser: fb.control({
        value: value?.modifiedUser
          ? (value?.modifiedUser?.firstName + " " + value?.modifiedUser?.lastName)
          : value?.creationUser ? (value?.creationUser?.firstName + " " + value?.creationUser?.lastName) : ""
        , disabled: true
      }, []),

    });
  }

  onSubmit() {
    const site = new Site(
      this.siteForm.value
    )
    this.uiService.addRouteLoading();
    this.siteService.createOrUpdateSite(site).subscribe(data => {
      this.siteDetail.isEditMode = false;
      this.siteDetail.isCreationMode = false;
      this.siteDetail.isReadOnlyMode = true;
      this.siteDetail.site = data;
      this.siteDetailEmit.emit();
      this.initFormBuilder(data);
      this.uiService.displayMessageToast('site.success-edit');
      this.uiService.removeRouteLoading();
      if (this.dialogRef) {
        this.dialogRef.close({
          success: true,
          data
        });
      }

    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }
  onCancel() {
    this.siteDetail.isEditMode = false;
    this.siteDetail.isReadOnlyMode = true;
    if (this.siteDetail?.id) {
      this.uiService.addRouteLoading();
      this.siteService.getSite(this.siteDetail?.id).subscribe(site => {
        this.initFormBuilder(site);
        this.uiService.removeRouteLoading();
      }, error => {
        console.error(error);
        this.uiService.removeRouteLoading();
      })
    }
  }
  onEdit() {
    this.siteDetail.isEditMode = true;
    this.siteDetail.isReadOnlyMode = false;
    this.initFormBuilder(this.siteDetail.site);
  }
  onDelete() {

    if (this.siteDetail && this.siteDetail?.id) {
      const messageBoxParameter = new MessageBoxParameter();

      messageBoxParameter.message = this.translateService.instant('site.confirm-delete');
      messageBoxParameter.dialog = this.dialog;
      messageBoxParameter.title = 'Confirmation';
      messageBoxParameter.buttons = ['yes', 'no'];
      messageBoxParameter.width = "400px";

      MessageBox.show(messageBoxParameter).subscribe(mbResult => {
        if (mbResult && mbResult.value) {
          this.uiService.addRouteLoading();
          this.siteService.deleteSite(this.siteDetail?.id || "").subscribe(data => {
            this.uiService.displayMessageToast('site.success-delete');
            this.siteDetail.isEditMode = false;
            this.siteDetail.isReadOnlyMode = true;
            this.initFormBuilder();
            this.siteDetailEmit.emit();
            this.uiService.removeRouteLoading();
          }, error => {
            console.error(error);
            this.uiService.removeRouteLoading();
          });
        }
      });
    }
  }
  onPostPicture() {
    if (this.imageArray.length >= this.imageArrayMaxLength) {
      this.uiService.displayMessageToast('site-picture.max-picture-upload');
    }
    else {
      const fileUpload = this.fileUpload.nativeElement;
      fileUpload.onchange = () => {
        if (fileUpload.files[0].size > this.environment.maxFileSize) {
          this.uiService.displayMessageToast('label.file-size-exceeded');
        } else if (fileUpload.files[0].type === '' || !(fileUpload.accept.indexOf(fileUpload.files[0].type) > -1)) {
          this.uiService.displayMessageToast('label.file-extention-not-allowed');
        } else {
          let file = fileUpload.files[0];
          if (file) {
            this.uploadFile(file);
          }
        }
      };
      fileUpload.click();
    }

  }

  uploadFile(file: any) {
    if (file) {
      this.upload = true;
      let formData: FormData;
      formData = new FormData();
      formData.append('file', file);

      this.uiService.addRouteLoading();
      this.siteService.uploadPicture(
        this.siteDetail.id || "",
        formData).pipe(
          map(event => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                // this.document.progress = Math.round(event.loaded * 100 / event.total);
                break;
              case HttpEventType.Response:
                return event;
              case HttpEventType.Sent:
                return event;
            }
          }),
          catchError((error: HttpErrorResponse) => {
            this.upload = false;
            this.uiService.removeRouteLoading();
            return of(error);
          })).subscribe(data => {
            if (data && data.type === HttpEventType.Response) {
              this.uiService.removeRouteLoading();
              this.upload = false;
              const dataJson = JSON.parse(JSON.stringify(data)).body.data;
              this.getPicture();
            }
          }
          );
    }

  }

  getPicture() {
    this.imageArray = [];
    if (this.siteDetail.site && this.siteDetail.site?.id) {
      this.uiService.addRouteLoading();
      this.siteService.getPictures(this.siteDetail.site?.id || "").subscribe(data => {
        this.imageArray = data;
        this.uiService.removeRouteLoading();
      }, error => {
        console.error(error);
        this.uiService.removeRouteLoading();
      });
    }

  }

  onPictureClick(sitePicture: SitePicture) {
    const data = sitePicture;
    const dialogRef = this.dialog.open(SitePictureComponent, {
      data,
      hasBackdrop: true
    });

    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        this.getPicture();
      }
    })
  }

  onAddressChange(event: any) {
  }
  isRequiredField(field: string) {
    const form_field = <AbstractControl>this.siteForm.get(field);
    if (!form_field.validator) {
      return false;
    }

    const validator = form_field.validator({} as AbstractControl);
    return (validator && validator.required);
  }
}
